/*
 * @Author: qiaoshiteng
 * @Date: 2023-04-06 16:22:40
 * @LastEditors: qiaoshiteng
 * @LastEditTime: 2023-04-18 17:12:29
 * @Description: 
 */
import config from "@/config";
import http from "@/utils/request";

export default {
    user: {
        list: {
            url: `${config.MAIN_URL}/api/v1/maintenance/user/data`,
            name: "查机务人员列表",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        save: {
            url: `${config.MAIN_URL}/api/v1/maintenance/user/save`,
            name: "保存机务人员",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        delete: {
            url: `${config.MAIN_URL}/api/v1/maintenance/user/delete`,
            name: '删除机务人员',
            delete: async function (params) {
                return await http.delete(this.url + params);
            },
        },
        update: {
            url: `${config.MAIN_URL}/api/v1/maintenance/user/update`,
            name: "修改机务人员",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        nameList: {
            url: `${config.MAIN_URL}/api/v1/maintenance/user/name`,
            name: "机务人员名称模糊查询",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        }
    },
    tools: {
        list: {
            url: `${config.MAIN_URL}/api/v1/maintenance/tools/data`,
            name: "查工具列表",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        save: {
            url: `${config.MAIN_URL}/api/v1/maintenance/tools/save`,
            name: "保存工具",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        delete: {
            url: `${config.MAIN_URL}/api/v1/maintenance/tools/delete`,
            name: '删除工具',
            delete: async function (params) {
                return await http.delete(this.url + params);
            },
        },
        update: {
            url: `${config.MAIN_URL}/api/v1/maintenance/tools/update`,
            name: "修改工具",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        getCode: {
            url: `${config.MAIN_URL}/api/v1/maintenance/tools/getCode`,
            name: "获取工具编码",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
    },
    engineType: {
        list: {
            url: `${config.MAIN_URL}/api/v1/engine/type/data`,
            name: "查询发动机类型列表",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        save: {
            url: `${config.MAIN_URL}/api/v1/engine/type/save`,
            name: "保存发动机类型",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        delete: {
            url: `${config.MAIN_URL}/api/v1/engine/type/delete`,
            name: '删除发动机类型',
            delete: async function (params) {
                return await http.delete(this.url + params);
            },
        },
        update: {
            url: `${config.MAIN_URL}/api/v1/engine/type/update`,
            name: "修改发动机类型",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        getCode: {
            url: `${config.MAIN_URL}/api/v1/engine/type/getCode`,
            name: "获取发动机类型编码",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        getAll: {
            url: `${config.MAIN_URL}/api/v1/engine/type/data/all`,
            name: "查询发动机类型列表",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        }
    },
    engine: {
        list: {
            url: `${config.MAIN_URL}/api/v1/engine/data`,
            name: "查询发动机类型列表",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        save: {
            url: `${config.MAIN_URL}/api/v1/engine/save`,
            name: "保存发动机类型",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        delete: {
            url: `${config.MAIN_URL}/api/v1/engine/delete`,
            name: '删除发动机类型',
            delete: async function (params) {
                return await http.delete(this.url + params);
            },
        },
        update: {
            url: `${config.MAIN_URL}/api/v1/engine/update`,
            name: "修改发动机类型",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        getCode: {
            url: `${config.MAIN_URL}/api/v1/engine/getCode`,
            name: "获取发动机序号",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
    },
    airMaterial: {
        infoList: {
            url: `${config.MAIN_URL}/api/v1/airMaterial/info/data`,
            name: "查询航材出入库明细列表",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        save: {
            url: `${config.MAIN_URL}/api/v1/airMaterial/depository/inOut`,
            name: "航材总库出入库",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        depositoryList: {
            url: `${config.MAIN_URL}/api/v1/airMaterial/depository/data`,
            name: '查询航材总库列表',
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        airCodes: {
            url: `${config.MAIN_URL}/api/v1/airMaterial/depository/data/airCode`,
            name: '查询航材编码列表',
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        getDepository: {
            url: `${config.MAIN_URL}/api/v1/airMaterial/depository/getByAirCode`,
            name: '根据airCode查询航材总库',
            get: async function (params) {
                return await http.get(this.url + params);
            },
        },
    },
    partType: {
        list: {
            url: `${config.MAIN_URL}/api/v1/part/type/data`,
            name: "查询零件型列表",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        save: {
            url: `${config.MAIN_URL}/api/v1/part/type/save`,
            name: "保存零件类型",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        delete: {
            url: `${config.MAIN_URL}/api/v1/part/type/delete`,
            name: '删除零件类型',
            delete: async function (params) {
                return await http.delete(this.url + params);
            },
        },
        update: {
            url: `${config.MAIN_URL}/api/v1/part/type/update`,
            name: "修改零件类型",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        getByIsTimeControl: {
            url: `${config.MAIN_URL}/api/v1/part/type/getByIsTimeControl`,
            name: "修改零件类型",
            get: async function (params) {
                return await http.get(this.url + params);
            },
        },
    },
    part: {
        list: {
            url: `${config.MAIN_URL}/api/v1/part/data`,
            name: "查询零件型列表",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        save: {
            url: `${config.MAIN_URL}/api/v1/part/save`,
            name: "保存零件类型",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        delete: {
            url: `${config.MAIN_URL}/api/v1/part/delete`,
            name: '删除零件类型',
            delete: async function (params) {
                return await http.delete(this.url + params);
            },
        },
        update: {
            url: `${config.MAIN_URL}/api/v1/part/update`,
            name: "修改零件类型",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        getCode: {
            url: `${config.MAIN_URL}/api/v1/part/getCode`,
            name: "获取序号",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        }
    },
    configuration: {
        list: {
            url: `${config.MAIN_URL}/api/v1/configuration/data`,
            name: "查询零件型列表",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        },
        save: {
            url: `${config.MAIN_URL}/api/v1/configuration/save`,
            name: "保存零件类型",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        delete: {
            url: `${config.MAIN_URL}/api/v1/configuration/delete`,
            name: '删除零件类型',
            delete: async function (params) {
                return await http.delete(this.url + params);
            },
        },
        update: {
            url: `${config.MAIN_URL}/api/v1/configuration/update`,
            name: "修改零件类型",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        getCode: {
            url: `${config.MAIN_URL}/api/v1/configuration/getCode`,
            name: "获取序列号",
            get: async function (params) {
                return await http.get(this.url, params);
            },
        }
    },
    companyModel: {
        getCompanyModel: {
            url: `${config.MAIN_URL}/api/v1/company/model`,
            name: "机型",
            get: async function (params) {
                return await http.get(this.url + params);
            },
        },
        getCompanyModelNum: {
            url: `${config.MAIN_URL}/api/v1/company/model/num`,
            name: "机号",
            get: async function (params) {
                return await http.get(this.url + params);
            },
        },
    }
};
